import React, { useEffect, useRef, useState, Suspense } from "react";
import { useParams } from "react-router-dom";

import Spinner from "../../Components/Spinner";

// Services
import { vehicleService } from "../../../Services/vehicle.service";
import { visitsService } from "../../../Services/visits.service";

// Libs
import CryptoJS from "crypto-js";

// lazy imports devem vir também no topo
const GoogleMapComponent = React.lazy(() =>
  import("../../Components/Maps/GoogleMapComponent")
);

export default function ViewMap() {
  const { groupfilter, vehiclefilter, showVisits } = useParams();

  const [loading, setLoading] = useState(false);
  const [locations, setLocations] = useState([]);
  const [visitsLocations, setVisitLocations] = useState([]);
  const [initialFetch, setInitialFetch] = useState(true);
  const [startInterval, setStartInterval] = useState(false);
  const [createMap, setCreateMap] = useState(true);

  // Polling
  const intervalIdRef = useRef(null); // Referencia do intervalo de polling
  const lastReceivedRef = useRef(null); // mantém o último lastReceived
  const [delay] = useState(process.env.REACT_APP_UPDATE_FLEET_DATA_TIMER);

  const extractData = () => {
    const secretKey = process.env.REACT_APP_CRYPTO_SECRET;

    let groupFilterData = 0;
    let vehicleFilterData = 0;
    let showVisitsData = false;

    if (groupfilter) {
      console.log("Groups Filter URL param👇");
      console.log(groupfilter);

      groupFilterData = CryptoJS.AES.decrypt(
        decodeURIComponent(groupfilter.toString()),
        secretKey
      ).toString(CryptoJS.enc.Utf8);

      console.log("Groups Filter Decripted👇");
      console.log(vehicleFilterData);
    }

    if (vehiclefilter) {
      console.log("Vehicle Filter URL param👇");
      console.log(vehiclefilter);

      vehicleFilterData = CryptoJS.AES.decrypt(
        decodeURIComponent(vehiclefilter.toString()),
        secretKey
      ).toString(CryptoJS.enc.Utf8);

      console.log("Vehicle Filter Decripted👇");
      console.log(vehicleFilterData);
    }

    if (showVisits) {
      console.log("Show Visits Filter URL param👇");
      console.log(showVisits);

      showVisitsData = CryptoJS.AES.decrypt(
        decodeURIComponent(showVisits.toString()),
        secretKey
      ).toString(CryptoJS.enc.Utf8);

      showVisitsData = showVisitsData === "true";

      console.log("Show Visits Filter URL param👇");
      console.log(showVisitsData);
    }

    return {
      group: groupFilterData,
      vehicle: vehicleFilterData,
      showVisit: showVisitsData,
    };
  };

  // rotinas para atualizar apenas dados novos
  const updateSmartVehiclesList = (prevList, newList) => {
    let changed = false;

    const map = new Map(prevList.map((v) => [v.id, v]));
    const result = newList.map((newItem) => {
      const oldItem = map.get(newItem.id);
      if (!oldItem || oldItem.generatedAt !== newItem.generatedAt) {
        changed = true;
        return newItem;
      }
      return oldItem;
    });

    if (!changed) {
      return prevList; // <- retorna o mesmo array, sem trigger de render
    }

    return result;
  };

  // Buscar registros de frotas (GRID) e posições
  const fetchTrackingList = async (groupId, vehicleId) => {
    try {
      const trackingList = await vehicleService.fetchTrackVehiclesAll(Number(groupId), Number(vehicleId));

      if (trackingList && trackingList.vehiclesUser) {
        if (trackingList && Array.isArray(trackingList.vehiclesUser)) {
          const currentLastReceived = lastReceivedRef.current ?? 0;
          const newLastReceived = new Date(trackingList.lastReceived).getTime();
          if (!currentLastReceived) {
            setLocations(trackingList);
            lastReceivedRef.current = newLastReceived;
            return;
          }

          if (newLastReceived > currentLastReceived) {
            console.log("🆕 Nova atualização:", newLastReceived);
            lastReceivedRef.current = newLastReceived;

            setLocations((prev) => {
              const prevVehicles = Array.isArray(prev?.vehiclesUser)
                ? prev.vehiclesUser
                : [];

              const updatedVehicles = updateSmartVehiclesList(
                prevVehicles,
                trackingList.vehiclesUser
              );

              return {
                ...prev,
                ...trackingList,
                vehiclesUser: updatedVehicles,
              };
            });
          } else {
            console.log("📭 Nenhuma nova atualização.");
          }
        } else {
          console.warn("❌ Resultado inválido");
        }
      } else {
        console.warn("trackingList.vehiclesUser está undefined");
        setLocations([]); // Evita erros ao tentar renderizar dados indefinidos
      }

      return trackingList;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  const fetchVisits = async () => {
    console.log("🔥fetchVisits");

    try {
      const visits = await visitsService.fetchVisits(1, 0);

      console.log("Response de fetchVisits👇");
      console.log(visits);
      if (visits === null) {
        return null;
      } else {
        setVisitLocations(visits);
      }
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  const fetchData = async () => {
    const { group, vehicle, showVisit } = extractData();

    try {
      if (initialFetch) {
        setLoading(true);

        if (showVisit) {
          await fetchVisits();
        }
      }

      await fetchTrackingList(Number(group), Number(vehicle));
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // Executa ao entrar na tela (carregando os dados)
  useEffect(() => {
    (async () => {
      try {
        await fetchData();
        setInitialFetch(false);
        setStartInterval(true);
      } catch (error) {
        console.error("Erro ao buscar os dados de rastreamento:", error);
      }
    })();
  }, []);

  // Iniciar e Buscar por polling
  useEffect(() => {
    if (!startInterval) return;

    setCreateMap(false);

    const startPolling = () => {
      intervalIdRef.current = setInterval(async () => {
        console.log("🔄 Polling iniciado...");
        await fetchData();
      }, delay);
    };

    startPolling();

    return () => {
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
        intervalIdRef.current = null;
      }
    };
  }, [startInterval]);

  return (
    <Suspense fallback={<Spinner />}>
      <GoogleMapComponent
        mapLoading={loading}
        locations={locations}
        activeTab={"map"}
        createMap={createMap}
        hideIcons={true}
        visitsLocations={visitsLocations}
        handleClick={false}
      />
    </Suspense>
  );
}